module.exports = __webpack_public_path__ + "static/65-dd388873909ef49d5f4ff4b88bf84a4c.png";